import Keycloak from 'keycloak-js';

const keycloak = Keycloak();

export default keycloak;
